<template>
  <v-flex mb-0 xs12 mx-2>
    <v-layout row justify-start mx-3 mt-3 align-center>
      <div class="text-xs-left" style="font-sze: 20px; font-weight: 600;">Service Point Address</div>
    </v-layout>
    <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
      <v-layout hide-details justify-start row mt-0 mb-4>
        <!-- Left Column of fields -->
        <v-flex hide-details mx-4 xs4>
          <v-text-field
            style="max-height: 45px"
            v-model="servicePointAddress.Name"
            value="Name"
            label="Location Name*"
            required
            maxlength="40"
            :rules="requiredRules"
          ></v-text-field>
          <v-text-field
            style="max-height: 45px"
            v-model="servicePointAddress.Address1"
            value="Address1"
            label="Location Address 1*"
            required
            maxlength="40"
            :rules="requiredRules"
          ></v-text-field>
          <v-text-field
            style="max-height: 45px"
            v-model="servicePointAddress.Address2"
            value="Address2"
            label="Location Address 2"
            maxlength="40"
          ></v-text-field>
        </v-flex>
        <!-- Middle column -->
        <v-flex hide-details mx-4 xs4>
            <v-text-field
                style="max-height: 45px"
                v-model="servicePointAddress.City"
                value="City"
                label="City"
                required
                maxlength="40"
                :rules="requiredRules"
            ></v-text-field>
            <v-text-field
                style="max-height: 45px"
                v-model="servicePointAddress.StateProv"
                value="StateProv"
                label="State/Province*"
                required
                maxlength="2"
                mask="AA"
                :rules="requiredRules"
            ></v-text-field>
            <v-text-field
                style="max-height: 45px"
                v-model="servicePointAddress.PostalZip"
                value="PostalZip"
                label="Postal/Zip Code*"
                required
                maxlength="10"
                :rules="requiredRules"
            ></v-text-field>
        </v-flex>
        <!-- Right Column -->
        <v-flex hide-details mx-4 xs4>
            <v-textarea
                v-model="servicePointAddress.Notes"
                value="Notes"
                label="Notes"
                maxlength="100"
            ></v-textarea>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: "ServicePointAddress",
  props:{
    ServicePointAddress: {
      type: Object,
      default: null
    }
    },
    mounted(){
      if (this.ServicePointAddress !=null){
          this.servicePointAddress = Object.assign({},this.ServicePointAddress)
      }
    },
  data() {
      return {
        servicePointAddress: {},
        requiredRules: [v => !!v || ""]
      }
  }
};
</script>

<style scoped>
</style>